import { Toast as BaseToast } from '@base-ui/react'
import type { ReactNode } from 'react'

export interface ToastProviderProps {
  children: ReactNode
  limit?: number
  timeout?: number
}

/**
 * Toast Provider - Wraps your app to enable toast notifications
 *
 * @param children - App content
 * @param limit - Maximum number of toasts to show at once (default: 5)
 * @param timeout - Default auto-dismiss timeout in ms (default: 3000)
 */
export function ToastProvider({ children, limit = 5, timeout = 3000 }: ToastProviderProps) {
  return (
    <BaseToast.Provider timeout={timeout} limit={limit}>
      {children}
    </BaseToast.Provider>
  )
}
